import type { EditorPreviewCardEntry } from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const previewCardEntry: EditorPreviewCardEntry = {
  id: ComponentIdentifiers.rList,
  // Three stacked lines — the universal list glyph. A bullet character alone
  // reads as a dot at the palette's 24px, and a numbered glyph would name one
  // kind of list at the expense of the other.
  icon: '☰',
  label: 'List',
};
